export default "__VITE_ASSET__DUCt2v5v__"